import React, { useState } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ErrorMessage, RequiredMark } from "@components/inputs/shared";
import { CheckboxArrayFieldProps } from "../types";

export default function CheckboxArrayField(props: CheckboxArrayFieldProps) {
	const { t } = useTranslation();
	const { register, getValues, watch, clearErrors } = useFormContext();
	const {
		arrayList,
		name,
		disabledOption,
		checkboxFieldsLabel,
		required = false,
	} = props;

	const [disabled, setDisabled] = useState(false);
	const fieldResponse = getValues(name);
	watch(name);

	const handleDisabledCheckbox = () => {
		setDisabled(!disabled);
	};

	const checkboxFieldFormValidation = () => {
		if (fieldResponse == null) {
			return;
		}
		if (
			fieldResponse.fieldData != false ||
			fieldResponse.disableOption != false
		) {
			clearErrors(name);
		} else {
			return false;
		}
	};

	return (
		<div className="col col-sml-12 form__field">
			<label className="label">
				{t(checkboxFieldsLabel)}
				<RequiredMark required={required} />
			</label>

			<ErrorMessage
				name={name}
				customErrorMessage="COMMON.REQUIRED_FIELD"
			/>

			<div className="card card--primary card--divided">
				{arrayList.map((item) => (
					<div
						className="input--check col col-sml-12 form__field"
						key={item.id}
					>
						<input
							id={item.name}
							type="checkbox"
							className="input--check__box"
							value={item.code}
							disabled={
								fieldResponse != null &&
								fieldResponse.disableOption != false
							}
							{...register(`${name}.fieldData`, {
								validate: () => checkboxFieldFormValidation(),
							})}
						/>
						<label
							htmlFor={item.name}
							className="input--check__label"
						>
							{item.name}
						</label>
					</div>
				))}

				{disabledOption && (
					<div className="input--check col col-sml-12 form__field">
						<input
							id={disabledOption.name}
							type="checkbox"
							{...register(`${name}.disableOption`, {
								validate: () => checkboxFieldFormValidation(),
							})}
							className="input--check__box"
							value={disabledOption.code}
							onClick={handleDisabledCheckbox}
						/>
						<label
							htmlFor={disabledOption.name}
							className="input--check__label"
						>
							{disabledOption.name}
						</label>
					</div>
				)}
			</div>
		</div>
	);
}
